import type { LiliLinkButtonProps } from './LiliLink.types';
import { LiliLinkSize, LiliLinkType } from './LiliLink.types';
import { getLinkClassName } from './styles';
import { useFontClass } from '../../tokens';

export const LiliLinkButton = (props: LiliLinkButtonProps) => {
  const {
    type = LiliLinkType.DEFAULT,
    size = LiliLinkSize.MEDIUM,
    leftIcon,
    rightIcon,
    title,
    className,
    buttonType = 'button',
    testId,
    id,
    onClick,
  } = props;
  const { fontClass } = useFontClass();

  return (
    <span
      className={getLinkClassName(type, size, fontClass, className)}
      onClick={onClick}
      id={id}
      data-testid={testId}>
      {leftIcon}
      <button type={buttonType}>
        <span>{title}</span>
      </button>
      {rightIcon}
    </span>
  );
};
